var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:none;}\n\t.st2{fill:url(#SVGID_00000080925102699420165410000016201729565097722794_);}\n\t.st3{fill:url(#SVGID_00000071559642334291419040000016122842008945484460_);}\n\t.st4{fill:url(#SVGID_00000079488251505708246870000014427245208426358677_);}\n\t.st5{fill:url(#SVGID_00000031885774757040424500000010363139051293163945_);}\n\t.st6{fill:url(#SVGID_00000159452551972915319560000013204051767091934650_);}\n\t.st7{fill:url(#SVGID_00000102538342667464564460000002465985822997338300_);}\n\t.st8{fill:url(#SVGID_00000013881919710046605520000002629427248488221334_);}\n\t.st9{fill:url(#SVGID_00000065768713963711230620000015676825257369007258_);}\n\t.st10{fill:url(#SVGID_00000054231087235671863530000003139531858135257222_);}\n\t.st11{fill:url(#SVGID_00000147900827415572634750000017373425313593579656_);}\n\t.st12{fill:url(#SVGID_00000130649352962886792320000003653942049000610185_);}\n\t.st13{fill:url(#SVGID_00000001641045004745624240000003234023178259946889_);}\n\t.st14{fill:url(#SVGID_00000013896955553590137240000000745858575842812072_);}\n\t.st15{fill:url(#SVGID_00000057868939059847262970000013052910003466068903_);}\n\t.st16{fill:url(#SVGID_00000036968560726921350640000015098368711951812496_);}\n\t.st17{fill:url(#SVGID_00000057855980398404102150000000665383409856613506_);}\n\t.st18{fill:url(#SVGID_00000079469195964917428550000002367584316441662903_);}\n\t.st19{fill:url(#SVGID_00000060743881673407639410000016322978160253292177_);}\n\t.st20{fill:url(#SVGID_00000158738290801582354580000005241884372321501078_);}\n\t.st21{fill:url(#SVGID_00000026879123472527409920000004215241253369187001_);}\n\t.st22{fill:url(#SVGID_00000026142799197255020580000011147378225325463952_);}\n\t.st23{fill:#1F3151;}\n\t.st24{fill:url(#SVGID_00000121265580670990447680000004721386964656047273_);}\n\t.st25{fill:#FFFFFF;}\n\t.st26{fill:url(#SVGID_00000103988058409880681400000004260785122710504866_);}\n\t.st27{fill:url(#SVGID_00000145742839810965047540000011486979352769331887_);}\n\t.st28{fill:url(#SVGID_00000131344934533515969250000004652744758571861646_);}\n\t.st29{fill:url(#SVGID_00000098216521983031466920000002926437329682598822_);}\n\t.st30{fill:url(#SVGID_00000064327384093263088650000007489721524046588344_);}\n\t.st31{fill:url(#SVGID_00000108994972468680054590000005199819981489884046_);}\n\t.st32{fill:url(#SVGID_00000128479802827769448040000006033960725643288725_);}\n\t.st33{fill:url(#SVGID_00000103267282491346638700000011582475046601866157_);}\n\t.st34{fill:url(#SVGID_00000028303705807336432020000017850173629171403696_);}\n\t.st35{fill:url(#SVGID_00000117643304953761661540000002351666575253087423_);}\n\t.st36{fill:url(#SVGID_00000130617855287058876370000009317621802311648191_);}\n\t.st37{fill:url(#SVGID_00000159457192523024693850000015389351229445609356_);}\n\t.st38{fill:url(#SVGID_00000142147532430529655970000007822969499007706759_);}\n\t.st39{fill:url(#SVGID_00000179614989670723590710000003015112417997268367_);}\n\t.st40{fill:url(#SVGID_00000098900637791476607010000018426526834868308880_);}\n\t.st41{fill:url(#SVGID_00000069392700375194093740000010133398089093179267_);}\n\t.st42{fill:url(#SVGID_00000100383446622616653430000001945502997162808760_);}\n\t.st43{fill:url(#SVGID_00000005226723900270256080000012263782867452953231_);}\n\t.st44{fill:url(#SVGID_00000122693276883719290500000001619541265466192023_);}\n\t.st45{fill:url(#SVGID_00000075856260844055715550000002832894947772224660_);}\n\t.st46{fill:url(#SVGID_00000128460424145683101500000011392789804106697632_);}\n\t.st47{fill:url(#SVGID_00000125602867371871122210000005917678988810307980_);}\n\t.st48{fill:url(#SVGID_00000169522210785032336990000007170059050271410058_);}\n\t.st49{fill:url(#SVGID_00000024703928648772939260000006764900651497865115_);}\n\t.st50{fill:url(#SVGID_00000056421040819674046860000009178125301229525675_);}\n\t.st51{fill:url(#SVGID_00000093175623952818059790000007503548882319107717_);}\n\t.st52{fill:url(#SVGID_00000183944251339335144790000011328054064143130030_);}\n\t.st53{fill:url(#SVGID_00000056425882229777986260000002484067038519243451_);}\n\t.st54{fill:url(#SVGID_00000145026073824490396080000001088794587510181052_);}\n\t.st55{fill:url(#SVGID_00000140721344672284291400000007305338037621203110_);}\n\t.st56{fill:url(#SVGID_00000045579068372164206070000007737638479945146287_);}\n\t.st57{fill:url(#SVGID_00000159452018256476145420000002267313779845608608_);}\n\t.st58{fill:url(#SVGID_00000126283505680448393300000004390016519691720095_);}\n\t.st59{fill:url(#SVGID_00000147198945926022123000000008671149654897022617_);}\n\t.st60{fill:url(#SVGID_00000057841316703131905570000000878666239754445205_);}\n\t.st61{fill:url(#Path_3_00000080171646882089076710000013581424792081845643_);}\n\t.st62{fill:url(#Path_4_00000007409052721047454390000016418284443746980524_);}\n\t.st63{fill:url(#Path_5_00000104675925677354215530000006966898591431568529_);}\n\t.st64{fill:url(#Path_6_00000083773739273960088700000006996944210723741103_);}\n\t.st65{fill:url(#Path_7_00000034057770953574632910000009788518519359744134_);}\n\t.st66{fill:url(#Path_8_00000084493754038048729720000011962634311891807618_);}\n\t.st67{fill:url(#Path_9_00000003810224368897354200000010806190634239329208_);}\n\t.st68{fill:url(#Path_10_00000059988192666431434260000011405322557232102032_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.4157,
    y1: 974.0594,
    x2: 37.6329,
    y2: 966.3862,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.1-75.1c-2.2,0-4.5-0.1-6.5,1c-1.8,0.9-3.6,1.7-5.4,2.7c-0.6,0.3-1,0.3-1.6,0.1c-3.8-1.4-7.6-2.8-11.3-4.3 c-1.3-0.5-2.4-0.6-3.6,0.2c-1.2,0.8-2.6,1.3-3.9,2c3.6,2.3,7.1,4.6,10.6,6.9c-1.8,0.9-3.5,1.7-5.2,2.6c-0.9,0.5-1.6,0.5-2.4-0.1 c-1-0.7-2-1.6-3.1-1.6c-1,0-2.1,1-3.2,1.4c-0.6,0.3-0.6,0.5-0.2,0.9c1.7,1.9,3.3,3.8,4.9,5.8c0.3,0.4,0.6,0.4,1,0.4 c2.8,0,5.5,0,8.2,0c0.3,0,0.6,0,0.9-0.1c5.8-2.9,11.5-5.7,17.3-8.7c2.4-1.3,4.1-3.3,5.1-5.9C39.4-73.4,38.6-75.1,37.1-75.1z  M37.9-72.2c-1,2.5-2.7,4.4-5.1,5.7c-5.5,2.8-11,5.5-16.5,8.3C16-58,15.6-58,15.3-58c-2.6,0-5.1,0-7.7,0c-0.3,0-0.7,0-0.9-0.3 c-1.4-1.7-2.9-3.4-4.3-5.1c0.1-0.1,0.1-0.1,0.1-0.1c1.4-1.1,2.7-1.2,4.1,0c1.5,1.3,3,1.2,4.7,0.2c1.9-1.2,3.9-2,6-3 c-3.6-2.3-7.1-4.5-10.7-6.9c1.3-0.7,2.5-1.2,3.6-1.8c0.4-0.2,0.7,0,1,0.1c4.2,1.6,8.5,3.1,12.7,4.7c0.5,0.2,0.9,0.2,1.3-0.1 c1.9-1,3.9-1.9,5.8-2.9c1.9-1,4-0.9,6.1-0.9C37.9-74.1,38.3-73.2,37.9-72.2z"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80-92.8c-4.7,0-8.6,3.9-8.5,8.6c0,4.7,3.9,8.5,8.6,8.5s8.5-3.9,8.5-8.6C88.5-89,84.7-92.8,80-92.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013154422469769675580000006208429785550129080_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.5194,
    y1: 967.1,
    x2: 88.5323,
    y2: 967.1,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013154422469769675580000006208429785550129080_)"
    },
    d: "M87.5-71.4c-2.5,0-4.9,0-7.4,0 c-2.6,0-5.1,0-7.7,0c-0.4,0-1,0-1,0.5s0.6,0.5,1,0.5c5,0,10,0,15.1,0c0.4,0,1,0.1,0.9-0.5C88.5-71.5,88-71.4,87.5-71.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038382177709060444360000001288664646414189208_",
    gradientUnits: "userSpaceOnUse",
    x1: 65,
    y1: 958.15,
    x2: 95,
    y2: 958.15,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000038382177709060444360000001288664646414189208_)"
    },
    d: "M95-92.5c0-2.7-1.8-4.5-4.6-4.5 c-6.9,0-13.8,0-20.8,0c-2.7,0-4.6,1.8-4.6,4.5c0,8.4,0,16.8,0,25.3c0,2.8,1.9,4.5,4.6,4.5c6.9,0,13.8,0,20.7,0 c2.9,0,4.6-1.8,4.7-4.7c0-4.1,0-8.3,0-12.4C95-84.1,95-88.3,95-92.5z M93.9-67.7c0,2.7-1.2,3.9-3.8,3.9c-6.8,0-13.6,0-20.3,0 c-2.5,0-3.7-1.3-3.7-3.8c0-8.2,0-16.4,0-24.6c0-2.5,1.3-3.8,3.7-3.8c6.8,0,13.6,0,20.4,0c2.4,0,3.7,1.2,3.7,3.7c0,4.1,0,8.3,0,12.4 C93.9-75.9,93.9-71.8,93.9-67.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056420656134660199750000016804454783749252512_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.4498,
    y1: 953.75,
    x2: 88.5517,
    y2: 953.75,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056420656134660199750000016804454783749252512_)"
    },
    d: "M80-92.8c-4.7,0-8.6,3.9-8.5,8.6 c0,4.7,3.9,8.5,8.6,8.5s8.5-3.9,8.5-8.6C88.5-89,84.7-92.8,80-92.8z M87.4-85.4c0.1,0.5-0.1,0.7-0.6,0.7c-0.1,0-0.1,0-0.2,0 c-0.9,0-1.9,0.3-2.6-0.1c-0.7-0.4-0.4-1.6-0.6-2.5c-0.3-1.4-0.8-2.8-1.8-4.1C84.5-91,87.2-88.2,87.4-85.4z M80.7-90.9 c1.3,1.7,1.7,3.6,2,5.7c0.1,0.4-0.1,0.6-0.5,0.5c-0.7,0-1.4,0-2.1,0c-0.5,0-0.9,0-1.4,0c-1.4,0-1.4,0-1.2-1.3 c0.2-1.8,0.8-3.4,1.9-4.8C79.8-91.5,80.1-91.6,80.7-90.9z M78.5-91.4c-1.5,1.8-1.9,3.9-2.1,6.1c-0.1,0.5-0.2,0.7-0.7,0.7 c-0.8,0-1.7,0-2.6,0c-0.3,0-0.5,0-0.5-0.4C72.5-87.8,75.7-91.2,78.5-91.4z M72.6-82.9c-0.1-0.5-0.1-0.8,0.6-0.8 c0.9,0,2-0.2,2.7,0.1c0.9,0.4,0.5,1.6,0.7,2.5c0.3,1.5,0.9,2.8,1.9,4.2C75.4-77.6,73.1-80,72.6-82.9z M79.5-77.3 c-1.4-1.7-1.9-3.7-2.2-5.8c-0.1-0.5,0.1-0.6,0.6-0.6c0.7,0,1.4,0,2.1,0c0.2,0,0.4,0,0.5,0c2.3,0,2.3,0,1.8,2.2 c-0.3,1.6-0.9,3-1.9,4.2C80.2-76.9,79.9-76.9,79.5-77.3z M81.6-77c1.4-1.9,1.9-3.9,2.1-6c0.1-0.6,0.3-0.9,0.9-0.8 c0.7,0.1,1.5,0,2.2,0c0.6,0,0.7,0.2,0.6,0.8C87.1-80.2,84.6-77.5,81.6-77z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.2-94.9c-8.1,0-16.2,0-24.4,0c-0.7,0-0.9,0.2-0.9,0.9c0,4.7,0,9.4,0,14.1c0,4.8,0,9.5,0,14.2 c0,0.6,0.1,0.9,0.8,0.9c2.9,0,5.8,0,8.6,0c0.6,0,0.7-0.2,0.7-0.8c0-1.2-0.1-2.4,0.1-3.5c0.2-1.7,1.6-2.9,3.1-2.8 c1.6,0.1,2.8,1.3,2.8,3.1c0,1,0,2.1,0,3.1c0,0.6,0.1,0.9,0.8,0.9c2.8,0,5.6,0,8.4,0c0.7,0,0.9-0.2,0.9-0.9c0-9.5,0-18.9,0-28.4 C153.1-94.8,152.9-94.9,152.2-94.9z M145.5-91.3c1-0.3,2.1-0.2,3.1,0c0.9,0.2,1,1.1,0.9,1.9c-0.1,1,0.4,2.2-0.9,2.8 c-0.5,0.2-1.1,0.1-1.5,0.1c-0.6,0-1.1,0-1.6-0.1c-0.9-0.3-1-1-1-1.9C144.6-89.5,144.1-90.9,145.5-91.3z M137.6-90.4 c0.1-0.6,0.6-1,1.2-1c0.4,0,0.8,0,1.2,0l0,0c0.4,0,0.7,0,1.1,0c0.7,0,1.1,0.4,1.3,1c0.2,0.9,0.2,1.9,0,2.8c-0.2,0.9-0.9,1.2-1.8,1.1 c-1.1-0.1-2.5,0.6-3-1C137.3-88.4,137.4-89.5,137.6-90.4z M142.5-80.4c0.1,0.8-0.1,1.7-1.1,1.9c-0.4,0.1-0.9,0-1.4,0s-0.9,0.1-1.4,0 c-0.9-0.2-1.2-0.9-1.1-1.8c0.1-1.1-0.5-2.5,1-3c0.9-0.3,2-0.2,2.9,0C142.9-82.9,142.4-81.5,142.5-80.4z M130.5-90.2 c0.1-0.7,0.6-1.2,1.3-1.2c0.4,0,0.7,0,1.1,0l0,0c0.5,0,0.9-0.1,1.4,0c0.9,0.2,1.2,1,1.1,1.8c-0.1,1.1,0.5,2.5-1.1,3 c-0.9,0.3-1.9,0.1-2.9,0c-0.6,0-0.9-0.5-1-1.1C130.5-88.5,130.4-89.4,130.5-90.2z M131.5-78.6c-1.7-0.6-0.9-2.2-1-3.4 c-0.1-0.9,0.5-1.4,1.5-1.4c0.3,0,0.7,0,1,0l0,0c0.5,0,0.9-0.1,1.4,0c1,0.2,1.1,1,1.1,1.9c-0.1,1.1,0.4,2.5-1.1,2.9 C133.5-78.3,132.4-78.3,131.5-78.6z M144.8-73.1c-0.4,0.4-0.6,0-0.8-0.2c-1.1-1-2.4-1.6-4.1-1.6c-1.4,0-2.7,0.5-3.9,1.6 c-0.2,0.2-0.4,0.6-0.8,0.3c-0.4-0.4-0.1-0.7,0.2-0.9c2.3-2.5,6.9-2.6,9.2,0C144.9-73.7,145.2-73.4,144.8-73.1z M148.5-78.6 c-0.9,0.3-1.9,0.1-2.9,0c-0.4,0-0.8-0.3-0.9-0.7c-0.3-1.1-0.4-2.3,0-3.3c0.4-1.1,1.4-0.7,2.3-0.7c0.5,0,0.9-0.1,1.4,0 c0.9,0.2,1.2,1,1.1,1.8C149.4-80.5,150-79,148.5-78.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.1-70.9c-1.2,0-2,0.8-2.1,2c0,0.8,0,1.5,0,2.3c0,1.7,0,1.7,1.7,1.7c2.4,0,2.4,0,2.4-2.3c0-0.5,0-1.1,0-1.6 C142-70.1,141.2-70.9,140.1-70.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139284181767483232980000012691160002981012630_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.0556,
    y1: 963.5601,
    x2: 144.9828,
    y2: 963.5601,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139284181767483232980000012691160002981012630_)"
    },
    d: "M135.4-74c-0.2,0.3-0.6,0.6-0.2,0.9 c0.4,0.3,0.6-0.1,0.8-0.3c1.1-1,2.4-1.6,3.9-1.6c1.6,0,3,0.6,4.1,1.6c0.2,0.2,0.4,0.6,0.8,0.2s0.1-0.6-0.2-0.9 C142.3-76.5,137.7-76.5,135.4-74z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103946378557554904360000003367620478916955831_",
    gradientUnits: "userSpaceOnUse",
    x1: 124,
    y1: 957.9596,
    x2: 156.002,
    y2: 957.9596,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103946378557554904360000003367620478916955831_)"
    },
    d: "M155.4-64.9c-0.1,0-0.3,0-0.4,0 c-0.8,0.1-1-0.2-1-1c0-9.2,0-18.3,0-27.5c0-0.5-0.1-1.1,0.1-1.5c0.2-0.4,0.9-0.1,1.3-0.2c0.3,0,0.6-0.2,0.6-0.5 c0-0.3-0.2-0.5-0.6-0.5c-0.2,0-0.3,0-0.5,0c-10,0-19.9,0-29.9,0c-0.4,0-1-0.1-1,0.5c0,0.6,0.6,0.6,1,0.5c0.8-0.1,1,0.2,1,1 c0,9.2,0,18.5,0,27.7c0,1,0,1.7-1.3,1.4c-0.3-0.1-0.6,0.1-0.7,0.5c0,0.4,0.3,0.6,0.7,0.5c0.2,0,0.4,0,0.6,0c4.9,0,9.8,0,14.7,0 c4.5,0,9,0,13.6,0c0.6,0,1.3,0,1.9,0c0.3,0,0.6-0.1,0.6-0.5C156-64.8,155.7-64.9,155.4-64.9z M139.6-64.9c-1.7,0-1.7,0-1.7-1.7 c0-0.8,0-1.5,0-2.3c0.1-1.3,0.9-2.1,2.1-2c1.2,0,1.9,0.8,1.9,2.1c0,0.5,0,1.1,0,1.6C142-64.9,142-64.9,139.6-64.9z M153.1-65.6 c0,0.7-0.1,0.9-0.9,0.9c-2.8,0-5.6,0-8.4,0c-0.7,0-0.8-0.2-0.8-0.9c0.1-1,0-2.1,0-3.1c0-1.7-1.2-3-2.8-3.1c-1.6-0.1-2.9,1-3.1,2.8 c-0.1,1.2-0.1,2.3-0.1,3.5c0,0.5-0.1,0.8-0.7,0.8c-2.9,0-5.8,0-8.6,0c-0.7,0-0.8-0.3-0.8-0.9c0-4.8,0-9.5,0-14.2s0-9.4,0-14.1 c0-0.7,0.2-0.9,0.9-0.9c8.1,0,16.2,0,24.4,0c0.7,0,0.9,0.1,0.9,0.9C153.1-84.6,153.1-75.1,153.1-65.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086682073323087554980000015868237082566108315_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.4722,
    y1: 949.0355,
    x2: 135.514,
    y2: 949.0355,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086682073323087554980000015868237082566108315_)"
    },
    d: "M135.5-89.6c0.1-0.8-0.2-1.6-1.1-1.8 c-0.4-0.1-0.9,0-1.4,0l0,0c-0.4,0-0.7,0-1.1,0c-0.8,0-1.3,0.5-1.3,1.2c-0.1,0.8-0.1,1.7,0,2.5c0.1,0.6,0.4,1.1,1,1.1 c1,0.1,2,0.2,2.9,0C136-87.1,135.4-88.5,135.5-89.6z M132.9-87.4c-1.4,0-1.4,0-1.4-1.5s0-1.5,1.5-1.5s1.5,0,1.5,1.5 S134.5-87.4,132.9-87.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001628233993087308450000017354644285933487289_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.5095,
    y1: 949.0678,
    x2: 149.5487,
    y2: 949.0678,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001628233993087308450000017354644285933487289_)"
    },
    d: "M149.5-89.4c0-0.8-0.1-1.7-0.9-1.9 c-1-0.2-2.1-0.3-3.1,0c-1.4,0.5-0.9,1.8-1,2.9c-0.1,0.8,0.1,1.6,1,1.9c0.5,0.1,1,0.1,1.6,0.1c0.4,0,1.1,0.1,1.5-0.1 C149.9-87.2,149.5-88.4,149.5-89.4z M146.9-87.4c-1.4,0-1.4,0-1.4-1.6c0-1.5,0-1.5,1.5-1.5s1.5,0,1.5,1.5 C148.6-87.4,148.6-87.4,146.9-87.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147900841411539413180000004546991316029773752_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.4767,
    y1: 957.0472,
    x2: 142.5362,
    y2: 957.0472,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147900841411539413180000004546991316029773752_)"
    },
    d: "M141.4-83.3c-0.9-0.2-2-0.2-2.9,0 c-1.6,0.5-0.9,1.9-1,3c-0.1,0.8,0.2,1.6,1.1,1.8c0.4,0.1,0.9,0,1.4,0s0.9,0.1,1.4,0c1-0.2,1.1-1,1.1-1.9 C142.4-81.5,142.9-82.9,141.4-83.3z M140-79.4c-1.5,0-1.5,0-1.5-1.6c0-1.4,0-1.4,1.5-1.4s1.5,0,1.5,1.5S141.5-79.4,140-79.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044883760071580923160000012426478874719090334_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.4285,
    y1: 949.0843,
    x2: 142.5518,
    y2: 949.0843,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044883760071580923160000012426478874719090334_)"
    },
    d: "M142.4-90.4c-0.1-0.7-0.6-1-1.3-1 c-0.4,0-0.7,0-1.1,0l0,0c-0.4,0-0.8,0-1.2,0c-0.6,0-1.1,0.4-1.2,1c-0.2,1-0.3,2,0,2.9c0.5,1.6,1.9,0.9,3,1c0.8,0.1,1.6-0.1,1.8-1.1 C142.6-88.5,142.6-89.5,142.4-90.4z M140-87.4c-1.5,0-1.5,0-1.5-1.6c0-1.5,0-1.5,1.5-1.5s1.5,0,1.5,1.6 C141.5-87.4,141.5-87.4,140-87.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017490164284656884110000012287356215323863209_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.4082,
    y1: 957.0724,
    x2: 135.5061,
    y2: 957.0724,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017490164284656884110000012287356215323863209_)"
    },
    d: "M135.5-81.5c0.1-0.8-0.1-1.7-1.1-1.9 c-0.4-0.1-0.9,0-1.4,0l0,0c-0.3,0-0.7,0-1,0c-0.9,0-1.5,0.5-1.5,1.4c0.1,1.2-0.7,2.8,1,3.4c0.9,0.3,2,0.2,2.9,0 C135.9-79,135.4-80.4,135.5-81.5z M133-79.4c-1.5,0-1.5,0-1.5-1.6c0-1.5,0-1.5,1.6-1.5c1.5,0,1.5,0,1.5,1.7 C134.5-79.4,134.5-79.4,133-79.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045590352907270910250000005718020986991519918_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.462,
    y1: 956.9722,
    x2: 149.5629,
    y2: 956.9722,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045590352907270910250000005718020986991519918_)"
    },
    d: "M149.5-81.6c0.1-0.8-0.2-1.6-1.1-1.8 c-0.4-0.1-0.9,0-1.4,0c-0.8,0-1.9-0.3-2.3,0.7s-0.3,2.2,0,3.3c0.1,0.4,0.5,0.7,0.9,0.7c1,0,2,0.2,2.9,0 C150-79,149.4-80.5,149.5-81.6z M147-79.4c-1.5,0-1.5,0-1.5-1.6c0-1.5,0-1.5,1.5-1.5c1.6,0,1.6,0,1.6,1.7 C148.6-79.4,148.5-79.4,147-79.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161612811035408706380000016760427887688531369_",
    gradientUnits: "userSpaceOnUse",
    x1: -156.98,
    y1: 942.55,
    x2: -150.7192,
    y2: 942.55,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161612811035408706380000016760427887688531369_)"
    },
    d: "M-153.8-94.9c-0.8,0-1.6,0-2.3,0 c-0.4,0-0.8-0.1-0.8-0.6c0-0.4,0.4-0.5,0.8-0.5c1.6,0,3.2,0,4.8,0c0.4,0,0.8,0.1,0.7,0.6c0,0.4-0.4,0.5-0.8,0.5 C-152.3-94.9-153.1-94.9-153.8-94.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140001070718674322400000016226743929518073272_",
    gradientUnits: "userSpaceOnUse",
    x1: -161.2925,
    y1: 957.1358,
    x2: -127.3025,
    y2: 957.1358,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140001070718674322400000016226743929518073272_)"
    },
    d: "M-131.8-95.9c-2.6,0-5.2,0-7.9,0 c-5.2,0-4-0.5-8.2,2.7c-0.5,0.4-1,0.5-1.6,0.5c-2.4,0-4.8,0-7.2,0c-2.8,0-4.6,1.8-4.7,4.6c0,5.9,0,11.8,0,17.7 c0,2.8,1.8,4.6,4.6,4.6c4.1,0,8.2,0,12.3,0c4.2,0,8.4,0,12.5,0c2.7,0,4.5-1.8,4.5-4.5c0-7,0-14,0-21 C-127.3-94.1-129.1-95.9-131.8-95.9z M-160.3-88.1c0-2.2,1.3-3.5,3.5-3.5c2.6,0,5.1,0,7.7,0c0.6,0,1.2-0.1,1.6-0.6 c2.2-2.3,4.9-3,8-2.7c2.5,0.2,5.1,0,7.6,0.1c2.2,0,3.4,1.3,3.5,3.4c0,1.4,0,2.7,0,4.1s0,2.7,0,4.1c0,0.5-0.1,0.8-0.7,0.7 c-2.4,0-4.9,0-7.3,0c-0.7,0-0.8-0.4-1.1-0.8c-2.6-4.4-8.4-5.3-12.2-1.9c-0.7,0.6-1.3,1.3-1.7,2.2c-0.2,0.4-0.5,0.6-1,0.6 c-2.4,0-4.8,0-7.2,0c-0.7,0-0.8-0.3-0.8-0.9C-160.2-85-160.3-86.6-160.3-88.1z M-137.3-79.3c0,3.8-3.1,6.9-6.9,6.9 c-3.9,0-6.9-3.1-6.9-7s3.1-7,6.9-7C-140.4-86.3-137.3-83.1-137.3-79.3z M-128.3-70.4c0,2.1-1.3,3.4-3.4,3.4c-4.2,0-8.4,0-12.5,0 c-4.1,0-8.2,0-12.3,0c-2.3,0-3.6-1.3-3.6-3.7c0-3.3,0-6.6,0-9.9c0-0.8,0.2-1,0.9-1c2.2,0.1,4.3,0,6.5,0c0.6,0,0.8,0,0.7,0.8 c-0.5,3.4,0.7,6.2,3.5,8c2.8,1.8,5.8,1.8,8.6,0c2.9-1.8,4-4.6,3.6-8c-0.1-0.7,0-0.9,0.8-0.9c2.2,0.1,4.3,0,6.5,0 c0.6,0,0.9,0.1,0.9,0.8C-128.4-77.2-128.3-73.8-128.3-70.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078723719245407027500000005703049453188250275_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.2776,
    y1: 1060.4465,
    x2: 143.848,
    y2: 1060.4465,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078723719245407027500000005703049453188250275_)"
    },
    d: "M141.6,20.1c-1.3,0-2.3,1-2.3,2.4 c0,1.3,1,2.2,2.3,2.3c1.3,0,2.3-0.9,2.3-2.3C143.8,21,142.9,20,141.6,20.1z M141.5,23.5c-0.7,0-1.2-0.5-1.1-1.2 c0-0.7,0.5-1.1,1.2-1.1c0.7,0,1.1,0.5,1.1,1.1C142.7,23.1,142.3,23.5,141.5,23.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105404351087521036190000008472353279057300873_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.1773,
    y1: 1060.3966,
    x2: 120.7477,
    y2: 1060.3966,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105404351087521036190000008472353279057300873_)"
    },
    d: "M118.4,20.1c-1.3,0-2.2,1-2.2,2.3 s1,2.3,2.3,2.3s2.3-1,2.3-2.4C120.7,21,119.8,20,118.4,20.1z M118.6,23.5c-0.8,0-1.3-0.5-1.3-1.1c0-0.7,0.4-1.2,1.1-1.2 s1.2,0.4,1.2,1.1C119.6,23.1,119.2,23.4,118.6,23.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089568054347080020630000011408161524132206010_",
    gradientUnits: "userSpaceOnUse",
    x1: 111.5082,
    y1: 1058.1,
    x2: 148.4913,
    y2: 1058.1,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089568054347080020630000011408161524132206010_)"
    },
    d: "M148.4,22c-0.1-2.4-1.3-4.3-3.4-5.6 c-0.6-0.3-0.9-0.8-1-1.4c-0.7-2.4-1.3-4.9-2.1-7.3c-0.7-2.4-2.7-3.8-5.2-3.8c-2.2,0-4.5,0-6.7,0c-2.1,0-4.2,0-6.3,0 c-3.1,0-4.9,1.4-5.8,4.4c-0.6,2.3-1.3,4.5-1.9,6.8c-0.2,0.6-0.5,1-1.1,1.4c-1.9,1.1-3.2,2.8-3.3,5.1c-0.3,4.2-0.1,8.4-0.1,12.6 c0,1.4,1,2.1,2.4,2.1c0.7,0,1.5,0,2.2,0c1.4,0,2.2-0.9,2.3-2.2c0-0.9,0-1.8,0-2.8c0-0.6,0.2-0.8,0.8-0.8c7.2,0,14.4,0,21.6,0 c0.6,0,0.8,0.1,0.8,0.8c-0.1,0.9-0.1,1.9,0,2.8c0.1,1.4,1,2.2,2.4,2.2c0.7,0,1.5,0,2.2,0c1.4,0,2.3-0.9,2.3-2.2 C148.5,30,148.5,26,148.4,22z M119.3,7.9c0.7-2,2-2.8,4.1-2.8c4.5,0,9,0,13.5,0c1.8,0,3.3,1,3.9,2.7c0.8,2.3,1.4,4.7,2.1,7.1 c0.2,0.8-0.3,0.6-0.7,0.6c-8.3,0-16.6,0-25.1,0C117.8,12.9,118.5,10.4,119.3,7.9z M117.2,34.2c-0.7,1.5-2.2,0.6-3.3,0.8 c-0.8,0.1-1.2-0.4-1.3-1.2c0-1,0-1.9,0-2.9c0-0.5,0.2-0.6,0.6-0.6c0.6,0,1.2,0,1.7,0c2.3,0,2.3,0,2.3,2.3 C117.3,33.3,117.4,33.8,117.2,34.2z M129.9,29.3c-5.3,0-10.7,0-16,0c-1.1,0-1.3-0.3-1.2-1.3c0.1-2.3-0.2-4.5,0.2-6.8 c0.5-2.8,2.7-4.6,5.6-4.7c7.7,0,15.5,0,23.2,0c3.2,0,5.6,2.2,5.7,5.5c0.1,2.2,0,4.4,0.1,6.6c0,0.9-0.5,0.7-1,0.7 C140.9,29.3,135.4,29.3,129.9,29.3z M147.3,34.2c-0.7,1.5-2.2,0.6-3.3,0.8c-0.8,0.1-1.2-0.4-1.3-1.2c-0.1-1,0-1.9,0-2.9 c0-0.5,0.2-0.6,0.6-0.6c0.6,0,1.2,0,1.7,0c2.3,0,2.3,0,2.3,2.3C147.3,33.3,147.5,33.8,147.3,34.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031906342679488435330000018153004422610067339_",
    gradientUnits: "userSpaceOnUse",
    x1: 171,
    y1: 1058.7,
    x2: 179.523,
    y2: 1058.7,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031906342679488435330000018153004422610067339_)"
    },
    d: "M174.8,26.8c0-2.4,0-4.8,0-7.2 c0-0.6-0.1-0.7-0.7-0.7c-2.3,0-3.1-0.8-3.1-3.2c0-2.6,0-5.3,0-7.9c0-0.2,0-0.4,0-0.6c0-0.3,0.1-0.7,0.5-0.7c0.4,0,0.4,0.4,0.4,0.7 c0,1.3,0,2.7,0,4c0,1.6,0,3.2,0,4.8c0,1.5,1.1,2.4,2.6,1.9c0.5-0.1,0.3-0.5,0.3-0.8c0-3,0-6,0-9c0-0.2,0-0.4,0-0.6 c0-0.4-0.1-1,0.5-1c0.6,0,0.4,0.6,0.4,1c0,3.2,0,6.3,0,9.5c0,0.7,0.1,0.9,0.9,0.9c1.6-0.1,2-0.4,2-2c0-2.7,0-5.4,0-8.2 c0-0.2,0-0.4,0-0.7c0-0.3,0.2-0.6,0.5-0.6s0.4,0.3,0.4,0.6c0,0.4,0,0.8,0,1.2c0,2.6,0,5.3,0,7.9c0,1.7-0.9,2.7-2.6,2.6 c-0.9,0-1.2,0.2-1.2,1.2c0.1,4.6,0,9.2,0,13.9c0,0.2,0,0.5,0,0.8c0,0.2-0.2,0.3-0.4,0.4c-0.2,0-0.4-0.1-0.4-0.3 c-0.1-0.3-0.1-0.6-0.1-0.8C174.8,31.5,174.8,29.1,174.8,26.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090992506893594566560000001162334640503895738_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.9883,
    y1: 1068.5702,
    x2: 203.98,
    y2: 1068.5702,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090992506893594566560000001162334640503895738_)"
    },
    d: "M204,26.5c-1.9,4.1-5,6.8-9.4,8 c-6.4,1.7-13.1-1.3-16.2-7.2c-0.1-0.3-0.7-0.7-0.1-1c0.6-0.4,0.7,0.2,0.9,0.6c2.8,5,7.2,7.4,12.9,7c4.7-0.3,8.3-2.7,10.6-6.8 C202.9,26.6,203.2,26.2,204,26.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098214538023903612850000014455535467830803118_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.4484,
    y1: 1046.8373,
    x2: 200.4435,
    y2: 1046.8373,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098214538023903612850000014455535467830803118_)"
    },
    d: "M200.1,11.1c-4.5-4.3-12.5-5.4-18.6,0.1 c-0.2-0.7,0-1.2,0.6-1.7c5.2-4.1,12.9-4,17.8,0.1C200.5,10.2,200.6,10.5,200.1,11.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148625376432573822340000011692529562437395604_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.3376,
    y1: 1058.7162,
    x2: 208.9974,
    y2: 1058.7162,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148625376432573822340000011692529562437395604_)"
    },
    d: "M209,7.7c-0.1-0.9-0.8-1.4-1.6-1.1 c-2.9,1.2-5,3.1-5.6,6.2c-0.7,3.3-0.3,6.8-0.2,10.1c0,1,0.8,1.6,1.9,1.6c1.2,0,2.5,0.1,3.7,0c0.9-0.1,1,0.3,1,1 c-0.1,2.7,0,5.4,0,8.2c0,0.2,0,0.5,0,0.7c0,0.3,0.1,0.6,0.5,0.5c0.3,0,0.4-0.3,0.4-0.6c0-0.2,0-0.4,0-0.7c0-4.2,0-8.5,0-12.7 c0-3.7,0-7.4,0-11C209,9.2,209,8.5,209,7.7z M207.3,23.6c-1.3,0-2.5,0-3.8,0c-0.7,0-1.2-0.3-1.2-1.1c0.1-3-0.2-6,0.2-9s2.4-4.8,5-6 c0.7-0.3,0.6,0.3,0.6,0.7c0,2.4,0,4.9,0,7.3s0,4.9,0,7.3C208.1,23.5,207.9,23.6,207.3,23.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160151157422076802660000002502154665105926837_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.4,
    y1: 1058.8,
    x2: 199.48,
    y2: 1058.8,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160151157422076802660000002502154665105926837_)"
    },
    d: "M191.1,12.2c-4.8,0-8.7,3.8-8.7,8.6 c0,4.7,3.8,8.5,8.5,8.6c4.8,0,8.6-3.7,8.6-8.5C199.5,16.1,195.8,12.2,191.1,12.2z M191,28.4c-4.2,0-7.7-3.4-7.7-7.6s3.4-7.6,7.7-7.6 c4.2,0,7.6,3.4,7.6,7.6S195.2,28.4,191,28.4z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M-125.5-170c-3.1-2-6.1-3.9-9.1-5.9c-0.4-0.3-1-0.5-0.9-1.2c0-0.6,0.5-0.8,1-1.1c0.8-0.4,1.5-0.7,2.3-1.1 c1.1-0.6,2.2-0.6,3.3-0.1c3.9,1.5,7.8,2.9,11.7,4.4c0.6,0.2,1.1,0.2,1.8-0.1c1.8-0.9,3.7-1.8,5.4-2.7c2.1-1.1,4.5-1,6.7-1 c1.6,0,2.5,1.7,1.8,3.3c-1.1,2.7-2.9,4.9-5.5,6.2c-5.7,3-11.5,5.8-17.3,8.7c-0.4,0.2-0.9,0.3-1.3,0.3c-2.6,0-5.3,0-7.9,0 c-0.8,0-1.4-0.2-2-0.9c-1.3-1.6-2.7-3.1-4.1-4.7c-0.8-0.9-0.7-1.5,0.4-2.1c0.4-0.2,0.8-0.4,1.1-0.6c0.9-0.5,1.7-0.5,2.6,0.1 c0.8,0.5,1.7,1,2.6,1.4c0.3,0.1,0.5,0.3,0.8,0.2C-129.7-167.9-127.6-168.9-125.5-170z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097468855889698478000000001187392918722471049_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.7553,
    y1: 988.3,
    x2: 36.4553,
    y2: 988.3,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097468855889698478000000001187392918722471049_)"
    },
    d: "M20.1-49.1c-5.1,0-10.3,0-15.4,0 c-0.2,0-0.4,0-0.7,0c-0.2,0-0.3-0.3-0.3-0.6s0.1-0.5,0.4-0.6c0.2,0,0.4,0,0.6,0c10.2,0,20.5,0,30.7,0c0.2,0,0.4,0,0.6,0 c0.2,0,0.4,0.2,0.4,0.6c0,0.4-0.2,0.6-0.4,0.6s-0.4,0-0.7,0C30.3-49.1,25.2-49.1,20.1-49.1z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M-138.8-166.9c1.4-1.1,2.7-1.2,4.3-0.2c2.9,1.8,1.9,1.6,4.9,0.2c1.3-0.6,2.7-1.3,4-2c0.5-0.2,1.1-0.4,1.1-1.1 c0-0.7-0.5-0.9-1-1.2c-2.7-1.8-5.5-3.5-8.2-5.2c-0.2-0.2-0.5-0.3-0.8-0.6c1.1-0.5,2.1-1.1,3.1-1.5c0.8-0.4,1.7-0.2,2.5,0.1 c3.9,1.4,7.8,2.9,11.7,4.4c0.8,0.3,1.5,0.3,2.3-0.1c1.8-1,3.7-1.9,5.6-2.8c2-1,4.1-0.9,6.2-0.9c0.9,0,1.3,1.1,0.9,2.1 c-1.1,2.5-2.8,4.5-5.3,5.8c-5.6,2.9-11.3,5.7-16.9,8.5c-0.3,0.1-0.6,0.2-0.9,0.2c-2.7,0-5.3,0-8,0c-0.4,0-0.7,0-1-0.3 C-135.8-163.4-137.3-165.1-138.8-166.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127008660526807500890000002877748285572921739_",
    gradientUnits: "userSpaceOnUse",
    x1: -121.66,
    y1: 1027.4,
    x2: -110.6571,
    y2: 1027.4,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127008660526807500890000002877748285572921739_)"
    },
    d: "M-116.1-5c3,0,5.5-2.5,5.5-5.6 c0-3-2.5-5.6-5.5-5.6s-5.5,2.5-5.5,5.5C-121.7-7.5-119.2-5-116.1-5z M-116.1-15.2c2.5,0,4.6,2.1,4.6,4.7c0,2.5-2.1,4.6-4.6,4.6 c-2.6,0-4.6-2.1-4.6-4.7C-120.7-13.1-118.7-15.2-116.1-15.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011008536154665656600000006673598250248838810_",
    gradientUnits: "userSpaceOnUse",
    x1: -145.9453,
    y1: 1021.4958,
    x2: -107.8886,
    y2: 1021.4958,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011008536154665656600000006673598250248838810_)"
    },
    d: "M-108.7-14c-1.7-3.7-3.5-7.3-5.3-11 c-0.5-1.1-1.3-2-2.4-2.5c-0.7-0.4-1.2-0.9-1.5-1.6c-0.6-1.2-1.7-1.8-3.1-1.8c-1.4,0.1-2.3,0.8-2.9,2c-0.4,0.8-0.3,1.6-0.2,2.4 c0,0.2,0,0.4-0.1,0.5c-1,1.3-1.4,2.7-1.2,4.4c0,0.3-0.1,0.4-0.3,0.3c-0.7-0.1-1.5-0.1-2.2,0c-0.3,0.1-0.4,0-0.3-0.3 c0.2-1.4-0.1-2.7-0.9-3.9c-0.4-0.5-0.4-1-0.4-1.6c0.2-1.4-0.5-2.6-1.7-3.3c-1.1-0.6-2.6-0.5-3.7,0.3c-0.6,0.5-0.9,1.1-1.2,1.8 c-0.1,0.2-0.2,0.5-0.5,0.6c-1.4,0.6-2.5,1.6-3.1,3c-0.7,1.4-1.4,2.9-2.1,4.3c-0.3,0.5-0.5,1.1-0.8,1.6c-0.1,0.3-0.1,0.5,0.2,0.6 c0.3,0.1,0.5,0,0.6-0.3l0.1-0.1c0.9-2,1.9-3.9,2.8-5.9c1.3-2.8,4.8-3.8,7.4-2.1c2,1.3,2.7,3.2,2.4,5.6c-0.3,2.3-0.5,4.7-0.7,7.1 c-0.1,0-0.1,0-0.2,0c-1.6-3.3-4.9-5.2-8.4-4.9c-4.7,0.5-7.9,4.8-7.3,9.3c0.5,3.8,3.5,6.8,7.3,7.3c4.3,0.5,8.3-2.6,9-6.9 c0.1-0.6,0.1-1.3,0.2-1.9c0-0.3,0.1-0.5,0.4-0.6c1.2-0.4,2.4-0.4,3.6-0.1c0.9,0.3,0.8,0.1,0.9,1.1c0,0.3,0.1,0.6,0.5,0.6 s0.4-0.3,0.5-0.6c0-0.5,0.1-1,0.2-1.4c0.8-3.6,4.2-6.1,7.7-5.8c3.8,0.4,6.7,3.3,6.8,7.1c0.1,3.1-1.8,6.1-4.6,7.2 c-3,1.2-6.4,0.3-8.4-2.2c-0.6-0.8-1.1-1.6-1.3-2.5c-0.1-0.3-0.3-0.5-0.6-0.4c-0.3,0.1-0.4,0.4-0.3,0.7v0.1c1.3,3.8,5.1,6.2,9.1,5.6 C-109.5-3.1-106.3-8.9-108.7-14z M-130.6-27c-1.4-1-2.9-1.5-4.6-1.2c0.2-1.1,1.6-1.9,2.8-1.6C-131.2-29.6-130.3-28.4-130.6-27z  M-137.7-3.1c-4.1,0-7.4-3.3-7.4-7.4s3.3-7.4,7.3-7.4c4.1,0,7.4,3.3,7.4,7.4C-130.3-6.4-133.6-3.1-137.7-3.1z M-128.9-15.9 c0.1-1.3,0.3-2.7,0.4-4c0-0.2,0.1-0.4,0.3-0.4c0.9-0.1,1.7-0.1,2.6,0c0.2,0,0.3,0.1,0.3,0.3c0.1,1.4,0.2,2.8,0.4,4.2 c0,0.2-0.1,0.3-0.3,0.2c-0.6-0.1-1.1-0.2-1.7-0.2s-1.2,0.1-1.7,0.2C-128.9-15.6-128.9-15.6-128.9-15.9z M-129.2-12.5 c0.1-0.7,0.1-1.3,0.2-1.9c0-0.1,0.2-0.1,0.3-0.2c1.2-0.4,2.5-0.4,3.7,0c0.2,0,0.2,0.1,0.3,0.3c0.1,0.6,0.1,1.2,0.2,1.9 C-126.4-13-127.4-13-129.2-12.5z M-118.3-18.6c-2.5,0.7-4.3,2.3-5.4,4.6l0,0c0,0-0.1,0-0.2,0l0,0c-0.2-2.4-0.4-4.7-0.7-7.1 c-0.3-2.1,0.2-3.9,1.9-5.3c0.8-0.7,1.8-1,2.8-1.1c0.3,0,0.6-0.1,0.5-0.5c0-0.3-0.3-0.4-0.6-0.4c-1,0-2,0.4-2.8,0.9 c-0.2,0.1-0.3,0.2-0.5,0.4c-0.4-1.3,0.7-2.9,2.2-2.9c1,0,1.7,0.4,2.2,1.2c0.2,0.4,0.4,0.8,0.6,1.2c0.1,0.2,0.3,0.4,0.5,0.5 c1.4,0.5,2.3,1.4,3,2.8c1.1,2.2,2.1,4.4,3.2,6.6c0,0.1,0.1,0.2,0.2,0.5C-113.5-18.8-115.8-19.2-118.3-18.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086670265881974371340000015351591946514643898_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.16,
    y1: 1027.45,
    x2: -132.16,
    y2: 1027.45,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086670265881974371340000015351591946514643898_)"
    },
    d: "M-137.7-16.1c-3,0-5.5,2.5-5.5,5.6 s2.5,5.5,5.5,5.5s5.5-2.5,5.5-5.6C-132.2-13.6-134.7-16.1-137.7-16.1z M-137.7-5.9c-2.5,0-4.6-2.1-4.6-4.6c0-2.6,2.1-4.6,4.6-4.6 s4.6,2.1,4.6,4.6S-135.1-5.9-137.7-5.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013904341920695844060000010018226044559351170_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.8217,
    y1: 1144.369,
    x2: 130.4395,
    y2: 1144.369,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013904341920695844060000010018226044559351170_)"
    },
    d: "M129.9,109.5c-1.9-2.1-3.8-4.2-5.7-6.3 c-0.2-0.3-0.3-0.5-0.1-0.8c0.2-0.3,0.3-0.7,0.5-1c0.1-0.2,0.1-0.5-0.1-0.6c-0.3-0.1-0.4,0-0.5,0.3c0,0.1-0.1,0.2-0.1,0.3 c-1.7,3.7-3.5,7.3-5.3,10.9c-0.2,0.3-0.3,0.5-0.7,0.3c-0.7-0.2-1.4-0.3-2.1-0.2c-0.3,0-0.6,0-0.9-0.2c-1-0.5-1.2-1.9-0.3-2.6 c1.3-1,2.2-2.2,2.5-3.8c0.1-0.5,0.3-0.7,0.7-0.8c1.6-0.5,2.5-2.3,1.7-3.7c-0.2-0.3-0.2-0.6,0-0.9c1-2.7,0.5-5.1-1.4-7.2 c-0.2-0.2-0.3-0.4-0.4-0.6c-0.6-1.5-1.6-2.5-3.2-2.9c-3.3-0.9-6.6-1.4-9.9-0.8c-2,0.3-3.7,1.2-4.8,2.9c-0.4,0.6-0.7,1.2-1.1,1.7 c-0.6,0.8-1.3,1.4-2.2,1.5c-1.1,0.1-1.4,0.8-0.9,1.7c0.9,1.8,2.3,3,4.3,3.5c-0.2,0.1-0.3,0.3-0.4,0.4c-0.9,0.8-1.2,2.3-0.8,3.4 c0.5,1.1,1.4,1.6,2.5,1.5c0.2,0,0.3,0.1,0.3,0.3c0.4,1.6,1.3,2.9,2.7,3.8c0.1,0.1,0.2,0.1,0.2,0.2c0.3,0.6-0.1,1.8-0.6,2.2 c-0.4,0.3-0.9,0.3-1.4,0.3c-3.2,0.1-5.4,1.6-6.7,4.4c-0.7,1.4-0.6,3-0.6,4.5c0,1.7,1.2,2.9,3,2.9c7.7,0,15.5,0,23.2,0 c1.4,0,2.2-0.9,2.3-2.2c0-0.7,0-1.4,0-2.1c-0.1-3-1.4-5.3-4-6.7c-0.1-0.1-0.4-0.1-0.3-0.3c0.1-0.2,0.1-0.5,0.4-0.5 c0.1,0,0.3,0,0.4,0c3,0,5.9,0,8.8,0c0.8,0,1.4-0.3,1.7-1C130.6,110.6,130.4,110,129.9,109.5z M111.2,91.2c0.2,0,0.5,0.1,0.5,0.4 s-0.3,0.4-0.4,0.3c-0.3,0-0.6,0-0.6-0.4C110.7,91.2,111,91.2,111.2,91.2z M100.7,94c1-1.6,2.5-2.3,4.3-2.6c0.7-0.1,1.4-0.1,2.2-0.1 c0.5,0,0.9,0,1.4,0c0.2,0,0.5,0,0.5,0.4c0,0.3-0.2,0.3-0.5,0.3c-1.1,0-2.3-0.1-3.4,0.1c-1.6,0.3-3,0.9-3.9,2.3 c-0.1,0.2-0.3,0.4-0.6,0.2C100.5,94.4,100.6,94.2,100.7,94z M103.7,108.5c-1-0.9-1.6-1.9-1.7-3.2c-0.1-0.7-0.2-0.7-0.8-0.5 c-1.1,0.4-2.3-0.7-2.1-2c0.2-1.5,1.1-2.2,3.2-2.2c1.5,0.1,3.4,0.2,5.3,0.1c1.9-0.1,3.8,0,5.6-0.5c0.6-0.2,1.2-0.4,1.7-0.8 c0.2-0.2,0.3-0.1,0.5,0.1c0.6,1,1.4,1.6,2.6,1.7c0.6,0.1,0.8,0.5,0.9,1c0.2,1.2-0.7,2.2-1.9,2.3c-0.4,0-0.6,0.2-0.6,0.6 c-0.2,2-1.3,3.4-3,4.4C110.4,111.1,106.1,110.7,103.7,108.5z M113.3,112.6c-0.7,1.8-2.5,2.9-4.5,2.9c-1.7-0.1-3.5-1.5-4-3.2 c0-0.2-0.1-0.3,0-0.4c0.2-0.4,0.2-0.9,0.2-1.4c3.7,1.1,4.7,1.1,8.1,0.1c0,0.5,0.1,1,0.3,1.5C113.5,112.2,113.3,112.4,113.3,112.6z  M112,123.4c-3.7,0-7.3,0-11,0c-0.4,0-0.6-0.1-0.5-0.6c0-0.8,0-1.7,0-2.5c0-0.3,0-0.5-0.4-0.5s-0.4,0.3-0.4,0.5c0,0.9,0,1.8,0,2.7 c0,0.3-0.1,0.4-0.4,0.4c-0.6,0-1.2,0-1.8,0c-0.9,0-1.8-0.8-1.8-1.7c0-1.2-0.2-2.5,0.2-3.7c0.8-2.8,3.4-4.8,6.3-4.8 c0.6,0,1.2,0,1.8-0.3c0.3-0.2,0.3,0.1,0.4,0.3c0.7,1.5,1.9,2.6,3.5,3c2.3,0.7,4.8-0.5,5.9-2.7c0.1-0.2,0.2-0.4,0.3-0.7 c0.8,0.6,1.8,0.3,2.7,0.4c1.1,0.1,1.2,0.1,0.7,1.1c-1.5,2.9-3.1,5.8-4.6,8.7C112.6,123.3,112.4,123.4,112,123.4z M122.5,119.4 c0.1,0.8,0,1.7,0,2.5c0,0.9-0.5,1.4-1.4,1.4c-1,0-2,0-2.9,0c-0.4,0-0.5-0.1-0.5-0.5c0-0.8,0-1.7,0-2.5c0-0.3,0-0.5-0.3-0.5 c-0.4,0-0.4,0.3-0.4,0.6c0,0.9,0,1.7,0,2.6c0,0.3,0,0.5-0.4,0.5c-1,0-2,0-3,0c0.8-1.5,1.5-2.9,2.3-4.3c0.9-1.7,1.8-3.4,2.6-5 c0.2-0.3,0.3-0.4,0.6-0.2C121.1,115.1,122.3,116.9,122.5,119.4z M125,110.7c-0.9,0-1.8,0.1-2.7,0.1c-0.3,0-0.7,0.1-0.7-0.3 s0.4-0.3,0.7-0.3c0.4,0,0.8,0,1.2,0v-0.1c0.5,0,1,0,1.5,0c0.2,0,0.4,0,0.5,0.3C125.5,110.7,125.3,110.7,125,110.7z M126.5,110.7 c-0.2,0-0.4-0.1-0.4-0.3c0-0.3,0.2-0.4,0.4-0.4c0.2,0,0.3,0.1,0.4,0.3C126.8,110.6,126.7,110.7,126.5,110.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039101431271893345530000003871116494380844471_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.7294,
    y1: 1155.1455,
    x2: 115.7339,
    y2: 1155.1455,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039101431271893345530000003871116494380844471_)"
    },
    d: "M113,119.5c-0.2,0-0.4-0.3-0.2-0.6 c0.7-1.3,1.5-2.6,2.2-3.9c0.1-0.2,0.3-0.3,0.5-0.1c0.2,0.1,0.2,0.3,0.1,0.5c-0.7,1.3-1.4,2.5-2.2,3.8 C113.4,119.4,113.3,119.5,113,119.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022550894563539698210000005510750103271288708_",
    gradientUnits: "userSpaceOnUse",
    x1: 111.9332,
    y1: 1158.65,
    x2: 112.7763,
    y2: 1158.65,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022550894563539698210000005510750103271288708_)"
    },
    d: "M112.8,120.6c-0.1,0.3-0.1,0.6-0.5,0.6 c-0.2,0-0.4-0.2-0.3-0.5c0.1-0.3,0.1-0.6,0.5-0.6C112.7,120.1,112.8,120.3,112.8,120.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043451496242470672180000001907891311892411058_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.9959,
    y1: 1145.6367,
    x2: 110.9304,
    y2: 1145.6367,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043451496242470672180000001907891311892411058_)"
    },
    d: "M108.9,108.7c-0.7-0.1-1.4-0.4-1.8-1.1 c-0.1-0.2-0.2-0.5,0.1-0.7c0.3-0.1,0.4,0.1,0.6,0.3c0.3,0.6,0.8,0.8,1.5,0.7c0.6-0.1,0.9-0.4,0.9-1c0-0.2,0.2-0.4,0.4-0.3 c0.2,0,0.3,0.2,0.4,0.4C111,107.9,110.1,108.7,108.9,108.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057857011803998236690000002667154516295568027_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.552,
    y1: 1141.6,
    x2: 105.3417,
    y2: 1141.6,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057857011803998236690000002667154516295568027_)"
    },
    d: "M105.3,103.6c0,0.1,0,0.3,0,0.4 c0,0.2-0.1,0.4-0.4,0.4c-0.3,0-0.4-0.2-0.4-0.4c0-0.2,0-0.5,0-0.7c0-0.3,0.1-0.5,0.4-0.5s0.4,0.2,0.4,0.5 C105.3,103.3,105.3,103.5,105.3,103.6L105.3,103.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147939344753970382920000018105356130341589161_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.4302,
    y1: 1141.4867,
    x2: 113.2218,
    y2: 1141.4867,
    gradientTransform: "matrix(1 0 0 1 0 -1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147939344753970382920000018105356130341589161_)"
    },
    d: "M112.4,103.5c0-0.2,0-0.3,0-0.5 s0.2-0.4,0.4-0.3c0.2,0,0.4,0.1,0.4,0.3c0,0.3,0,0.5,0,0.8s-0.1,0.5-0.4,0.5s-0.4-0.2-0.4-0.5C112.4,103.8,112.4,103.7,112.4,103.5 L112.4,103.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055672040322607290970000011848515570001800112_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.3259,
    y1: 232.7341,
    x2: 85.7703,
    y2: 232.7341,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000055672040322607290970000011848515570001800112_)"
    },
    d: "M74.3-190.2c1.8-0.2,3.6-0.4,5.3-0.7 c1.4-0.2,2.9-0.4,4.3-0.5c0.9-0.1,1.5,0.4,1.8,1.3c-0.1,0.1-0.2,0-0.3,0c-3.6,0-7.2,0-10.8,0C74.6-190.1,74.4-190,74.3-190.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105407794644523934840000012676978312343614910_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.6886,
    y1: 232.1,
    x2: 85.7703,
    y2: 232.1,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105407794644523934840000012676978312343614910_)"
    },
    d: "M74.3-190.2c0.1,0.1,0.2,0.1,0.3,0.1 c3.7,0,7.4,0,11.1,0h0.1c0,0.1-0.2,0.1-0.2,0.1c-3.8,0-7.7,0-11.5,0c-0.1,0-0.2,0-0.3,0C73.9-190.2,74.1-190.2,74.3-190.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155826599588889719030000013645075199426540930_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.9405,
    y1: 214.5047,
    x2: 100.4073,
    y2: 214.5047,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155826599588889719030000013645075199426540930_)"
    },
    d: "M99.4-173.5c-1.1-0.9-2.6-0.8-3.6,0.3 c-0.1,0.1-0.2,0.2-0.4,0.2c-2.1,0-4.3,0-6.4,0c-0.2,0-0.2-0.1-0.2-0.2c0-0.3,0-0.6,0-0.9c0-4.5,0-8.9,0-13.4c0-1.4-0.8-2.3-2.1-2.5 c-0.2,0-0.2-0.2-0.3-0.3c-0.3-1.1-1.2-1.8-2.3-1.7c-0.7,0.1-1.3,0.2-2,0.2c-2.6,0.3-5.2,0.6-7.8,1c-2.1,0.3-4.3,0.5-6.4,0.8 c-0.3,0-0.4,0.2-0.4,0.4s0,0.4,0,0.6c0,5.2,0,10.4,0,15.7c0,0.3-0.1,0.4-0.4,0.4c-0.6,0-1.1,0-1.7,0c-0.5,0-0.5,0.1-0.5,0.5 c0,5.7,0,11.3,0,17c0,0.3,0,0.6,0.1,0.9c0.4,1,1.2,1.5,2.3,1.5c4.8,0,9.7,0,14.5,0c4.9,0,9.7,0,14.6,0c0.5,0,1-0.1,1.4-0.4 c0.7-0.5,1-1.2,1-2.1c0-4.4,0-8.8,0-13.1c0-0.2,0-0.4,0.3-0.5s0.5-0.4,0.7-0.7C100.7-171,100.5-172.6,99.4-173.5z M68.5-189.4 c6,0,11.9,0,17.9,0c1,0,1.7,0.7,1.7,1.8c0,2.1,0,4.2,0,6.3c0,2.6,0,5.3,0,7.9c0,0.3-0.1,0.3-0.3,0.3c-1.2,0-2.4,0-3.7,0 c-0.1,0-0.2,0-0.3,0c1.9-3.3,0.7-6.8-1.5-8.6c-2.3-1.9-5.7-2-8-0.3c-1.4,1-2.3,2.4-2.7,4.1c-0.3,1.7,0,3.3,0.8,4.8 c-0.1,0.1-0.2,0-0.3,0c-1.2,0-2.5,0-3.7,0c-0.2,0-0.3,0-0.3-0.3c0-5.3,0-10.5,0-15.8C68.2-189.3,68.3-189.4,68.5-189.4z  M80.2-179.5c-0.5,0.1-1,0.2-1.5,0.2c-0.2,0-0.3,0-0.3-0.2c0-0.5,0-0.9,0-1.4c0-0.4,0-0.8,0-1.2c0-0.1-0.1-0.2,0.1-0.3 c0.1,0,0.2,0.1,0.3,0.1c0.6,0.4,0.9,0.9,1.2,1.5c0.2,0.3,0.2,0.7,0.4,1C80.5-179.6,80.4-179.5,80.2-179.5z M80.7-178.7 c0.1,0.5,0.1,1.1,0.2,1.6c0,0.2-0.1,0.3-0.3,0.3c-0.3,0-0.6,0-0.9,0s-0.6,0-0.9,0c-0.2,0-0.2,0-0.2-0.2c0-0.5,0-0.9,0-1.4 c0-0.2,0.1-0.2,0.2-0.2c0.6,0,1.1-0.1,1.7-0.2C80.6-178.9,80.6-178.9,80.7-178.7z M78.9-173.7c0.4,0,0.9,0.1,1.3,0.2 c0.1,0,0.2,0,0.2,0.2c0,0.1,0,0.3-0.2,0.3c-0.3,0-0.5,0-0.8,0c-0.2,0-0.4,0-0.6,0s-0.3-0.1-0.3-0.3 C78.5-173.7,78.5-173.7,78.9-173.7z M78.7-174.3c-0.2,0-0.2-0.1-0.2-0.2c0-0.5,0-0.9,0-1.4c0-0.2,0-0.2,0.2-0.2c0.3,0,0.6,0,1,0 c0.3,0,0.6,0,0.9,0c0.2,0,0.3,0,0.2,0.2c0,0.6-0.1,1.1-0.2,1.7c0,0.1-0.1,0.2-0.2,0.2C79.9-174.2,79.3-174.3,78.7-174.3z M80-182.1 c0.8,0.1,2.1,1,2.7,1.8c-0.5,0.2-0.9,0.4-1.4,0.6c-0.1,0-0.2,0.1-0.3-0.1C80.8-180.7,80.5-181.4,80-182.1z M82.9-179.8 c0.1-0.1,0.2-0.1,0.3,0.1c0.5,0.8,0.8,1.7,0.9,2.7c0,0.2-0.1,0.2-0.2,0.2c-0.4,0-0.7,0-1.1,0c-0.3,0-0.7,0-1,0 c-0.2,0-0.3,0-0.3-0.3c0-0.6-0.1-1.2-0.2-1.8c0-0.2,0-0.3,0.2-0.3C82-179.3,82.4-179.5,82.9-179.8z M81.1-173.2 c0.2-0.1,0.3,0,0.4,0.1c0,0.1,0,0.1,0,0.1c-0.1,0-0.3,0.1-0.4,0C81.1-173,81.1-173.1,81.1-173.2z M81.5-173.8 c-0.2-0.1-0.2-0.1-0.2-0.3c0.1-0.6,0.2-1.2,0.2-1.8c0-0.2,0.1-0.2,0.3-0.2c0.4,0,0.7,0,1.1,0s0.7,0,1.1,0c0.1,0,0.2,0,0.2,0.2 c-0.1,1-0.4,1.9-0.9,2.7c-0.1,0.1-0.2,0.2-0.3,0.1C82.5-173.5,82-173.6,81.5-173.8z M72.4-176.2c0.4,0,0.7,0,1.1,0s0.7,0,1.1,0 c0.2,0,0.2,0.1,0.2,0.2c0,0.6,0.1,1.3,0.2,1.9c0,0.1,0,0.2-0.2,0.2c-0.5,0.2-1,0.3-1.5,0.6c-0.1,0.1-0.2,0-0.3-0.1 c-0.5-0.8-0.8-1.7-0.9-2.7C72.2-176.1,72.3-176.2,72.4-176.2z M72.2-177c0.1-0.9,0.4-1.8,0.9-2.6c0.1-0.1,0.2-0.2,0.3-0.1 c0.5,0.2,1,0.5,1.5,0.6c0.2,0,0.2,0.1,0.1,0.2c-0.1,0.6-0.2,1.2-0.2,1.8c0,0.2-0.1,0.3-0.3,0.3c-0.3,0-0.7,0-1,0s-0.7,0-1,0 C72.3-176.8,72.2-176.8,72.2-177z M74.8-173.1c0.1-0.1,0.3-0.2,0.5-0.1c0,0,0.1,0.1,0,0.1C75.1-172.9,74.9-173,74.8-173.1 C74.8-173,74.8-173.1,74.8-173.1z M74.5-180c-0.2-0.1-0.4-0.2-0.7-0.3c-0.2-0.1-0.1-0.1,0-0.2c0.7-0.8,1.5-1.3,2.6-1.7 c-0.4,0.6-0.7,1.2-0.9,1.8C75.2-179.7,75.2-179.7,74.5-180z M75.7-178.7c0-0.1,0.1-0.2,0.2-0.2c0.5,0.1,1.1,0.2,1.7,0.2 c0.2,0,0.3,0.1,0.3,0.3c0,0.4,0,0.9,0,1.3c0,0.2-0.1,0.3-0.3,0.3c-0.3,0-0.6,0-0.9,0s-0.6,0-0.9,0c-0.2,0-0.3,0-0.2-0.2 C75.5-177.6,75.6-178.1,75.7-178.7z M75.7-176.2c0.3,0,0.7,0,1,0s0.6,0,0.9,0c0.2,0,0.2,0,0.2,0.2c0,0.4,0,0.9,0,1.3 c0,0.2,0,0.2-0.2,0.3c-0.6,0-1.2,0.1-1.7,0.3c-0.1,0-0.2,0-0.2-0.1c-0.1-0.6-0.1-1.2-0.2-1.7C75.5-176.1,75.5-176.2,75.7-176.2z  M76.1-173.5c0.5-0.1,1-0.2,1.5-0.2c0.2,0,0.2,0.1,0.2,0.2c0,0.2,0.2,0.4-0.2,0.4c-0.2,0-0.5,0-0.7,0s-0.5,0-0.7,0 s-0.3-0.1-0.3-0.3C75.9-173.5,76-173.5,76.1-173.5z M77.8-182c0,0.4,0,0.7,0,1.1c0,0.5,0,0.9,0,1.4c0,0.2-0.1,0.2-0.2,0.2 c-0.5-0.1-1-0.1-1.5-0.2c-0.1,0-0.2,0-0.2-0.2c0.3-0.9,0.6-1.8,1.3-2.4c0,0,0,0,0.1-0.1s0.3-0.3,0.5-0.2 C77.9-182.3,77.8-182.1,77.8-182z M96.5-153.8c-9.7,0-19.4,0-29.2,0c-1,0-1.7-0.7-1.7-1.7c0-5.5,0-11,0-16.6c0-0.3,0.1-0.3,0.3-0.3 c9.7,0,19.3,0,29,0c0.3,0,0.4,0.1,0.3,0.4c-0.1,0.4-0.1,0.9,0.1,1.3c0.1,0.3,0,0.3-0.2,0.3c-2,0-4,0-6,0c-0.2,0-0.3,0-0.5,0 c-0.3,0-0.4,0.1-0.4,0.4c0,0.7,0,1.4,0,2.1c0,0.3,0.2,0.4,0.5,0.4c1.6,0,3.2,0,4.8,0c0.1,0,0.2,0,0.4,0c-0.7,1.1-1.4,2.2-2.1,3.2 c-0.4,0.6-1.2,0.7-1.9,0.4c-0.8-0.4-1.6-0.4-2.4,0.1c-0.2,0.1-0.4,0.3-0.5,0.5c-0.2,0.3-0.2,0.5,0.1,0.6c0.3,0.2,0.3,0.3,0.2,0.6 c-0.3,0.5-0.3,0.5,0.2,0.8c2.2,1.3,4.4,2.6,6.6,3.8c0.4,0.2,0.5,0.2,0.7-0.2c0.1-0.1,0.1-0.2,0.1-0.3c0.1-0.2,0.2-0.1,0.3-0.1 c0.6,0.3,0.8,0.2,1-0.5c0.3-1-0.1-1.9-1-2.5c-0.8-0.5-0.9-1.3-0.5-2.1c0.1-0.2,0.2-0.3,0.2-0.5c0.9-1.7,1.7-3.4,2.6-5.2 c0.1-0.1,0.1-0.2,0.2-0.3c0.3-0.1,0.4,0,0.4,0.3c0,4.4,0,8.7,0,13.1C98.2-154.5,97.4-153.8,96.5-153.8z M95.3-169.7 c0,0.1-0.1,0.1-0.1,0.2c-0.2,0.4-0.5,0.7-0.7,1.1c-0.1,0.2-0.2,0.2-0.4,0.2c-1.7,0-3.3,0-5,0c-0.2,0-0.3-0.1-0.3-0.3 c0-0.3,0-0.7,0-1c0-0.2,0.1-0.3,0.3-0.3c1,0,2,0,3,0s2,0,3,0C95.1-169.7,95.2-169.8,95.3-169.7z M87.9-161.9 c0.1-0.2,0.2-0.1,0.3-0.1c2,1.2,4.1,2.3,6.1,3.5c0.1,0,0.1,0.1,0.2,0.1c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.1-0.2,0-0.3-0.1 c-1.4-0.8-2.9-1.7-4.3-2.5c-0.6-0.3-1.2-0.7-1.7-1C87.9-161.7,87.8-161.7,87.9-161.9z M99.7-171c-0.2,0.9-1,1.6-2,1.6 c-0.3-0.1-0.5,0.1-0.6,0.4c-1,2-2,4-3,5.9c-0.5,1.1-0.2,2.2,0.8,2.8c0.5,0.3,0.8,0.8,0.8,1.5c0,0.3-0.1,0.3-0.3,0.2 c-2-1.2-4-2.3-6-3.5c-0.5-0.3-0.9-0.5-1.4-0.8c-0.3-0.1-0.2-0.3,0-0.4c0.5-0.3,1-0.4,1.6-0.1c1.1,0.6,2.4,0.2,3.1-0.8 c1.2-1.9,2.4-3.7,3.6-5.5c0.2-0.3,0.1-0.4,0-0.7c-0.5-0.8-0.4-1.7,0.2-2.4c0.6-0.6,1.5-0.8,2.3-0.4C99.5-172.9,99.9-171.9,99.7-171 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133530264774855475260000014911689424627672720_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.5787,
    y1: 198,
    x2: 96.2621,
    y2: 198,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000133530264774855475260000014911689424627672720_)"
    },
    d: "M87.4-155.7c-2.7,0-5.5,0-8.2,0 c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3c0.1,0,0.2,0,0.3,0c5.5,0,11.1,0,16.6,0c0.1,0,0.2,0,0.3,0 c0.2,0,0.3,0.2,0.3,0.3c0,0.2-0.1,0.3-0.3,0.3c-0.1,0-0.2,0-0.3,0C92.9-155.7,90.2-155.7,87.4-155.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142881482320831991960000002788816127183498381_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.5797,
    y1: 200.1056,
    x2: 91.5173,
    y2: 200.1056,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142881482320831991960000002788816127183498381_)"
    },
    d: "M85-158.4c2,0,3.9,0,5.9,0 c0.1,0,0.2,0,0.3,0c0.2,0,0.3,0.1,0.3,0.3c0,0.2-0.1,0.3-0.2,0.3s-0.2,0-0.4,0c-3.9,0-7.8,0-11.7,0c-0.3,0-0.6,0-0.6-0.3 c0-0.4,0.3-0.3,0.6-0.3C81.1-158.4,83.1-158.4,85-158.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042705745600329201720000002378003472337570460_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.5849,
    y1: 207.3,
    x2: 91.5078,
    y2: 207.3,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042705745600329201720000002378003472337570460_)"
    },
    d: "M85.1-165.6c1.9,0,3.9,0,5.8,0 c0.1,0,0.2,0,0.3,0c0.2,0,0.3,0.1,0.3,0.3c0,0.2-0.1,0.3-0.3,0.3c-0.1,0-0.2,0-0.3,0c-3.9,0-7.8,0-11.7,0c-0.2,0-0.6,0.1-0.6-0.3 c0-0.4,0.3-0.3,0.6-0.3C81.1-165.6,83.1-165.6,85.1-165.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119097679748252458020000007560622384157256335_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.5769,
    y1: 201.6,
    x2: 88.4881,
    y2: 201.6,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119097679748252458020000007560622384157256335_)"
    },
    d: "M83.5-159.3c-1.5,0-2.9,0-4.4,0 c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2-0.1-0.2-0.3c0-0.2,0.1-0.3,0.2-0.3s0.2,0,0.3,0c2.9,0,5.8,0,8.8,0c0.1,0,0.2,0,0.3,0 c0.2,0,0.3,0.2,0.3,0.3c0,0.2-0.1,0.3-0.3,0.3c-0.1,0-0.2,0-0.3,0C86.5-159.3,85-159.3,83.5-159.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059275579993913933870000003351606338193883548_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.5697,
    y1: 205.2,
    x2: 86.4154,
    y2: 205.2,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059275579993913933870000003351606338193883548_)"
    },
    d: "M82.5-162.9c-1.2,0-2.3,0-3.5,0 c-0.2,0-0.4,0-0.4-0.3c0-0.3,0.2-0.3,0.4-0.3c2.3,0,4.7,0,7,0c0.3,0,0.4,0.1,0.4,0.4c0,0.2-0.2,0.2-0.4,0.2 C84.8-162.9,83.7-162.9,82.5-162.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080895529612035104640000013729766265708128675_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.5824,
    y1: 203.7,
    x2: 86.3938,
    y2: 203.7,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080895529612035104640000013729766265708128675_)"
    },
    d: "M82.5-162c1.1,0,2.3,0,3.4,0 c0.2,0,0.5,0,0.5,0.3s-0.2,0.3-0.5,0.3c-2.3,0-4.6,0-6.9,0c-0.2,0-0.5-0.1-0.5-0.3c0-0.3,0.2-0.3,0.5-0.3 C80.2-162,81.4-162,82.5-162z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101087898176535681930000011118425039923908522_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.7757,
    y1: 227.6,
    x2: 82.5614,
    y2: 227.6,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101087898176535681930000011118425039923908522_)"
    },
    d: "M78.2-185.3c-1.3,0-2.6,0-3.8,0 c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3-0.1-0.3-0.3s0.1-0.3,0.3-0.3c0.1,0,0.2,0,0.3,0c2.5,0,5.1,0,7.6,0c0.1,0,0.2,0,0.3,0 c0.2,0,0.3,0.1,0.3,0.3s-0.1,0.3-0.3,0.3c-0.1,0-0.2,0-0.2,0C80.7-185.3,79.4-185.3,78.2-185.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104706420143363910810000003618893700534392204_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.8152,
    y1: 229.2,
    x2: 80.5237,
    y2: 229.2,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104706420143363910810000003618893700534392204_)"
    },
    d: "M78.2-187.5c0.6,0,1.3,0,1.9,0 c0.2,0,0.4,0,0.4,0.3s-0.2,0.3-0.4,0.3c-1.3,0-2.6,0-3.9,0c-0.2,0-0.4-0.1-0.4-0.3s0.2-0.3,0.4-0.3 C76.9-187.5,77.5-187.5,78.2-187.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077291293385859262450000014019917206550183608_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.0853,
    y1: 213.7,
    x2: 99.3749,
    y2: 213.7,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000077291293385859262450000014019917206550183608_)"
    },
    d: "M99.4-171.5c0,0.3-0.1,0.6-0.2,0.8 s-0.2,0.2-0.4,0.1c-0.2-0.1-0.2-0.2-0.2-0.4c0.3-0.6,0.1-1-0.4-1.3c-0.1-0.1-0.2-0.3-0.1-0.4c0.1-0.2,0.3-0.2,0.4-0.1 C99.1-172.5,99.3-172.1,99.4-171.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077308439585949132180000006698877807149354644_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.5387,
    y1: 202.65,
    x2: 77.4314,
    y2: 202.65,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000077308439585949132180000006698877807149354644_)"
    },
    d: "M77.4-165.8c0-0.5-0.1-0.6-0.6-0.6 c-2.9,0-5.9,0-8.8,0c-0.5,0-0.6,0.1-0.6,0.5c0,3.5,0,6.9,0,10.4c0,0.4,0.1,0.6,0.6,0.6c2.9,0,5.9,0,8.8,0c0.5,0,0.5-0.1,0.5-0.6 c0-1.7,0-3.5,0-5.2C77.4-162.4,77.4-164.1,77.4-165.8z M75.4-155.6c-1,0-2,0-3,0s-2,0-3,0c-0.2,0-0.3-0.1-0.3-0.3 c0.2-1.2,0.9-1.9,1.9-2.4c0.1-0.1,0.3,0,0.4,0c0.7,0.3,1.3,0.3,2,0c0.1-0.1,0.2-0.1,0.3,0c1,0.5,1.7,1.2,1.9,2.4 C75.8-155.6,75.7-155.6,75.4-155.6z M76.6-155.6c-0.2,0-0.2-0.1-0.2-0.3c-0.2-1.4-1-2.3-2.2-3c-0.3-0.2-0.6-0.2-1,0 c-0.5,0.3-1,0.3-1.5,0c-0.2-0.1-0.5-0.2-0.8,0c-1.4,0.6-2.2,1.6-2.4,3.1c0,0.1,0,0.2-0.2,0.2s-0.1-0.2-0.1-0.3c0-1.6,0-3.2,0-4.8 s0-3.2,0-4.7c0-0.3,0.1-0.3,0.3-0.3c2.6,0,5.3,0,7.9,0c0.3,0,0.3,0.1,0.3,0.3c0,3.2,0,6.4,0,9.5C76.8-155.8,76.9-155.6,76.6-155.6z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041269957717745978460000000324192262499000466_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.5373,
    y1: 211,
    x2: 77.4373,
    y2: 211,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041269957717745978460000000324192262499000466_)"
    },
    d: "M77-170.4c-3,0-6,0-9,0 c-0.3,0-0.5,0.1-0.5,0.5c0,0.6,0,1.2,0,1.8c0,0.5,0.1,0.5,0.6,0.5c1.5,0,2.9,0,4.4,0s3,0,4.4,0c0.4,0,0.5-0.1,0.5-0.5 c0-0.7,0-1.3,0-2C77.4-170.3,77.3-170.4,77-170.4z M76.5-168.2c-1.3,0-2.6,0-4,0c-1.3,0-2.6,0-4,0c-0.3,0-0.4-0.1-0.3-0.3 c0-0.3,0-0.6,0-0.9c0-0.3,0.1-0.3,0.3-0.3c2,0,4,0,6.1,0c0.6,0,1.3,0,1.9,0c0.2,0,0.3,0.1,0.3,0.3c0,0.3,0,0.7,0,1 C76.8-168.2,76.7-168.2,76.5-168.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039120057342929901980000015206985253248830852_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.567,
    y1: 210.95,
    x2: 86.693,
    y2: 210.95,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039120057342929901980000015206985253248830852_)"
    },
    d: "M86.2-170.4c-2.4,0-4.8,0-7.2,0 c-0.3,0-0.5,0.1-0.5,0.5c0,0.6,0,1.3,0,1.9c0,0.4,0.1,0.5,0.5,0.5c1.2,0,2.4,0,3.5,0c1.2,0,2.4,0,3.6,0c0.4,0,0.5-0.1,0.5-0.5 c0-0.7,0-1.3,0-2C86.7-170.3,86.5-170.4,86.2-170.4z M86-168.4c0,0.2-0.1,0.3-0.2,0.3c-2.1,0-4.2,0-6.3,0c-0.2,0-0.3-0.1-0.3-0.3 c0-0.3,0-0.7,0-1s0.1-0.3,0.3-0.3c1,0,2.1,0,3.1,0s2,0,3,0c0.3,0,0.4,0.1,0.4,0.4C86-169.1,86-168.7,86-168.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122683132272526792540000014807707226470322085_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.4114,
    y1: 203.9554,
    x2: 74.5283,
    y2: 203.9554,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122683132272526792540000014807707226470322085_)"
    },
    d: "M74.5-162.8c0-1-0.8-1.9-1.7-2 c-1.1-0.1-2.1,0.5-2.3,1.5c-0.2,0.9-0.2,1.8,0,2.7s1.1,1.5,2,1.5c1,0,1.8-0.7,2-1.6c0.1-0.4,0-0.8,0.1-1.1 C74.5-162.2,74.5-162.5,74.5-162.8z M73.9-161.1c0,0.8-0.6,1.3-1.4,1.3c-0.7,0-1.3-0.6-1.4-1.3c0-0.6,0-1.1,0-1.7 c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.5,1.4,1.3c0,0.3,0,0.6,0,0.9l0,0C73.9-161.7,73.9-161.4,73.9-161.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161616515374732413580000009540940157708678309_",
    gradientUnits: "userSpaceOnUse",
    x1: -154.9,
    y1: -5.337,
    x2: -119.7688,
    y2: -5.337,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161616515374732413580000009540940157708678309_)"
    },
    d: "M-136.7,65.3c-10,0-18.2-8.2-18.2-18.2 c0-8.5,5.8-15.8,14.1-17.7c0.3-0.1,0.7,0.1,0.8,0.4s0.1,0.7-0.2,0.9c-3.8,2.8-6,7.2-6,11.9c0,8.2,6.7,14.9,14.9,14.9 c3.9,0,7.6-1.5,10.4-4.2c0.2-0.2,0.6-0.3,0.9-0.1s0.4,0.5,0.3,0.8C-122.7,60.9-129.3,65.3-136.7,65.3z M-143.5,31.7 c-6,2.6-10,8.6-10,15.4c0,9.3,7.5,16.8,16.8,16.8c5.8,0,11-2.9,14.1-7.6c-2.6,1.6-5.6,2.5-8.7,2.5c-9,0-16.3-7.3-16.3-16.3 C-147.6,38.5-146.2,34.7-143.5,31.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170268931966502725470000003998651012028067497_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.1965,
    y1: -44.5549,
    x2: -131.8637,
    y2: -44.5549,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170268931966502725470000003998651012028067497_)"
    },
    d: "M-131.9,84.7c0,0.3-0.1,0.5-0.3,0.7 c-1.2,1.2-2.3,2.3-3.5,3.5c-0.4,0.4-0.9,0.4-1.3,0.1c-0.3-0.3-0.3-0.9,0.1-1.3c1.2-1.2,2.3-2.4,3.5-3.5c0.3-0.3,0.6-0.4,1-0.2 C-132,84.1-131.9,84.3-131.9,84.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165218472919746908090000004781376611415537853_",
    gradientUnits: "userSpaceOnUse",
    x1: -157.8658,
    y1: -44.4165,
    x2: -152.539,
    y2: -44.4165,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165218472919746908090000004781376611415537853_)"
    },
    d: "M-152.5,88.3c0,0.7-0.7,1-1.3,0.7 c-0.1-0.1-0.2-0.2-0.3-0.3c-1.1-1.1-2.3-2.2-3.4-3.4c-0.5-0.5-0.5-1.2,0.2-1.5c0.4-0.2,0.7,0,1,0.2c1.2,1.2,2.4,2.3,3.5,3.5 C-152.6,87.9-152.5,88.1-152.5,88.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048499721092253140140000005833637726192766895_",
    gradientUnits: "userSpaceOnUse",
    x1: -157.8621,
    y1: -65.1536,
    x2: -152.5292,
    y2: -65.1536,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000048499721092253140140000005833637726192766895_)"
    },
    d: "M-157,109.8c-0.6,0-1-0.7-0.7-1.2 c0.1-0.1,0.2-0.3,0.3-0.4c1.1-1.1,2.2-2.3,3.4-3.4c0.5-0.5,1.3-0.4,1.5,0.2c0.1,0.4,0,0.7-0.2,1c-1.2,1.2-2.4,2.4-3.6,3.6 C-156.6,109.7-156.8,109.9-157,109.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054232725142717079230000005257381531883069330_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.1924,
    y1: -65.1314,
    x2: -131.8626,
    y2: -65.1314,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054232725142717079230000005257381531883069330_)"
    },
    d: "M-131.9,109c0,0.6-0.7,1-1.2,0.7 c-0.1-0.1-0.2-0.1-0.3-0.2c-1.2-1.2-2.3-2.3-3.5-3.5c-0.5-0.5-0.4-1.2,0.2-1.5c0.4-0.1,0.7,0,1,0.2c1.2,1.2,2.4,2.4,3.6,3.6 C-132,108.5-131.8,108.8-131.9,109z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120542761622987258500000006970391359670012563_",
    gradientUnits: "userSpaceOnUse",
    x1: -145.7194,
    y1: -40.2187,
    x2: -144.0086,
    y2: -40.2187,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120542761622987258500000006970391359670012563_)"
    },
    d: "M-144,82.2c0,0.8,0,1.6,0,2.5 c0,0.4-0.2,0.7-0.6,0.9c-0.4,0.1-0.7,0-1-0.3c-0.1-0.2-0.2-0.4-0.2-0.6c0-1.6,0-3.2,0-4.9c0-0.6,0.3-1,0.8-1s0.9,0.4,0.9,1 C-144,80.6-144,81.4-144,82.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064312536850938498400000001213785010049408436_",
    gradientUnits: "userSpaceOnUse",
    x1: -162.9106,
    y1: -54.9,
    x2: -156.059,
    y2: -54.9,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000064312536850938498400000001213785010049408436_)"
    },
    d: "M-159.5,96c0.8,0,1.7,0,2.5,0 c0.4,0,0.7,0.2,0.8,0.6c0.1,0.4,0,0.7-0.3,1c-0.2,0.1-0.4,0.2-0.6,0.2c-1.6,0-3.3,0-4.9,0c-0.6,0-1-0.4-1-0.9s0.4-0.8,1-0.8 C-161.1,96-160.3,96-159.5,96z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142175497915694132170000013570446778150883200_",
    gradientUnits: "userSpaceOnUse",
    x1: -133.6708,
    y1: -54.8,
    x2: -126.8202,
    y2: -54.8,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142175497915694132170000013570446778150883200_)"
    },
    d: "M-130.3,97.7c-0.8,0-1.6,0-2.5,0 c-0.4,0-0.7-0.2-0.9-0.6c-0.1-0.4,0-0.7,0.3-1c0.2-0.2,0.4-0.2,0.7-0.2c1.6,0,3.2,0,4.8,0c0.6,0,1,0.3,1,0.8s-0.4,0.9-1,0.9 C-128.6,97.7-129.5,97.7-130.3,97.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163065364654293234400000005655559598799636151_",
    gradientUnits: "userSpaceOnUse",
    x1: -145.721,
    y1: -69.4812,
    x2: -144.0098,
    y2: -69.4812,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163065364654293234400000005655559598799636151_)"
    },
    d: "M-145.7,111.4c0-0.8,0-1.7,0-2.5 c0-0.4,0.2-0.7,0.6-0.8c0.4-0.1,0.7,0,1,0.3c0.1,0.2,0.2,0.4,0.2,0.6c0,1.6,0,3.3,0,4.9c0,0.6-0.4,1-0.9,1s-0.8-0.4-0.8-1 C-145.7,113.1-145.7,112.3-145.7,111.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160157709989595670550000016889935899655663754_",
    gradientUnits: "userSpaceOnUse",
    x1: -153.453,
    y1: -54.9,
    x2: -136.2765,
    y2: -54.9,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160157709989595670550000016889935899655663754_)"
    },
    d: "M-144.9,88.3c-4.7,0-8.6,3.8-8.6,8.6 c0,4.7,3.9,8.6,8.6,8.6c4.8,0,8.6-3.9,8.6-8.6C-136.3,92.1-140.1,88.3-144.9,88.3z M-144.9,103.7c-3.8,0-6.9-3.1-6.9-6.9 s3.1-6.8,6.9-6.9c3.8,0,6.9,3.1,6.9,6.9S-141.1,103.7-144.9,103.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    transform: "translate(0 8.69)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_3_00000067220370086290863620000015442926896515984524_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.6,
    y1: 20.7923,
    x2: 39.3255,
    y2: 20.7923,
    gradientTransform: "matrix(1 0 0 -1 0 33.31)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    style: {
      fill: "url(#Path_3_00000067220370086290863620000015442926896515984524_)"
    },
    d: "M37.2-0.1 c-1.2,0-2.4,0-3.7,0c-2,0-4,0.6-5.7,1.6C26.6,2.3,25.3,3,24,3.7c-0.2,0.1-0.4,0.2-0.7,0.1c-3.3-1.1-6.7-2.2-10-3.3 c-0.3-0.1-0.6-0.1-0.9,0.1c-0.6,0.4-1.3,0.8-1.9,1.2c-0.7,0.4-0.7,0.9,0,1.3c2.1,1.5,4.2,3,6.3,4.5c0.1,0.1,0.3,0.1,0.3,0.3 c-2.4,1.4-4.8,2.9-7.3,4.3c-0.2,0.1-0.5,0.1-0.7,0C7.4,11.1,5.7,10,3.9,8.9c-0.3-0.2-0.7-0.2-1,0C2.3,9.2,1.6,9.6,1,10 c-0.2,0.1-0.4,0.3-0.4,0.5s0,0.5,0.2,0.6c1.5,1.8,3,3.5,4.5,5.3c0.1,0.1,0.1,0.3,0,0.4C4.9,17.5,5,18.4,5.5,19 c0.6,0.7,1.5,0.9,2.3,0.5c2.2-0.9,4.5-1.9,6.7-2.9c1-0.4,2.1-0.9,3.2-1.3c0,0.2,0,0.3,0,0.4l-0.6,8.6c0,0.7,0.3,1,1,0.8 c0.6-0.2,1.2-0.4,1.9-0.5c0.6-0.1,1-0.6,1.2-1.1c1.1-3.6,2.3-7.2,3.4-10.7c0.1-0.3,0.3-0.5,0.5-0.6c0.5-0.2,1.1-0.5,1.6-0.8 c2.5-1.1,5-2.5,7.3-4.1c1.9-1.3,3.5-2.8,4.8-4.7c0.4-0.5,0.6-1.2,0.5-1.8L39,0.4C38.5,0,37.9-0.2,37.2-0.1z M12,2.7 c-0.2-0.1-0.2-0.2,0-0.3c0,0,0,0,0.1,0c0.5-0.4,1.2-0.5,1.8-0.2c2.7,0.9,5.3,1.7,8,2.6c0.1,0,0.2,0.1,0.4,0.1 c-1.3,0.8-2.5,1.5-3.8,2.3c-0.1,0.1-0.2,0-0.3,0C16.1,5.6,14.1,4.1,12,2.7L12,2.7z M21.8,17.2c-0.6,1.9-1.2,3.8-1.8,5.7 c-0.1,0.3-0.3,0.6-0.6,0.7c-0.3,0.1-0.6,0.1-0.9,0.2c0-0.6,0.1-1.2,0.1-1.8c0.2-3,0.4-6,0.6-9c0-0.2,0-0.3,0.2-0.4 c1.5-0.7,3-1.4,4.5-2.2C23.2,12.7,22.5,14.9,21.8,17.2L21.8,17.2z M37.9,1.7c-1.1,1.6-2.4,3-4,4.1C31.5,7.6,29,9,26.2,10.2 c-0.2,0.1-0.3,0.2-0.5,0.2c-0.2,0.1-0.3,0.1-0.5,0.2c0.1-0.5,0.3-0.8,0.4-1.2c0.1-0.3,0.1-0.6-0.1-0.8s-0.6-0.2-0.8,0 c-2.1,1-4.1,2-6.2,3c-0.3,0.1-0.4,0.4-0.4,0.6c0,0.5-0.1,0.9-0.1,1.4c0,0.2-0.1,0.4-0.3,0.5c-1.6,0.7-3.1,1.3-4.7,2l-5.3,2.3 c-0.2,0.1-0.5,0.2-0.7,0.1s-0.3-0.2-0.4-0.3c-0.1-0.2-0.1-0.4,0-0.5s0.1-0.3,0.2-0.4C7,16.6,7,16.4,6.6,15.9 c-1.4-1.6-2.8-3.3-4.2-5c-0.1-0.2-0.1-0.2,0.1-0.3c0.3-0.2,0.6-0.4,1-0.5c0.3,0,0.6,0.3,0.9,0.5c1.5,1,3.1,2,4.6,3 c0.3,0.2,0.7,0.2,1.1,0c6.1-3.7,12.3-7.3,18.4-11c1.4-0.8,2.9-1.3,4.5-1.4h0.1c0.2,0,0.4,0.1,0.5,0.2s-0.1,0.2-0.1,0.3 c-0.1,0.2-0.2,0.3-0.4,0.4c-0.5,0.3-1,0.6-1.6,0.9c-0.2,0.1-0.2,0.2-0.1,0.4c0.2,0.3,0.3,0.7,0.5,0.8c0.2,0,0.5-0.3,0.8-0.4 c0.2-0.1,0.3-0.2,0.5-0.3C34,3.1,34.7,2.4,35,1.6c0.1-0.1,0.1-0.2,0.1-0.3c0-0.2,0.1-0.2,0.2-0.2c0.7,0,1.5,0,2.2,0 c0.2,0,0.3,0,0.4,0.2S38,1.6,37.9,1.7L37.9,1.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_4_00000126312924690064992120000006330793419794578610_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.9056,
    y1: 19.7638,
    x2: 13.4628,
    y2: 19.7638,
    gradientTransform: "matrix(1 0 0 -1 0 33.31)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    style: {
      fill: "url(#Path_4_00000126312924690064992120000006330793419794578610_)"
    },
    d: "M12.1,13.8 c-0.3-0.5-0.3-0.5,0.2-0.8c0.6-0.3,0.6-0.3,0.9,0.2c0.3,0.6,0.3,0.6-0.2,0.9C12.5,14.4,12.5,14.4,12.1,13.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_5_00000111185097889920348640000005860042055699046586_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.1134,
    y1: 21.1062,
    x2: 15.6593,
    y2: 21.1062,
    gradientTransform: "matrix(1 0 0 -1 0 33.31)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    style: {
      fill: "url(#Path_5_00000111185097889920348640000005860042055699046586_)"
    },
    d: "M15.4,11.9 c0.3,0.6,0.3,0.6-0.2,0.9c-0.5,0.3-0.5,0.3-0.9-0.2C14,12,14,12,14.6,11.6C15.1,11.3,15.1,11.3,15.4,11.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_6_00000179624280169809676750000008841329410684032402_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.3262,
    y1: 22.481,
    x2: 17.8894,
    y2: 22.481,
    gradientTransform: "matrix(1 0 0 -1 0 33.31)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    style: {
      fill: "url(#Path_6_00000179624280169809676750000008841329410684032402_)"
    },
    d: "M17.5,11.4 c-0.6,0.3-0.6,0.3-0.9-0.2s-0.3-0.5,0.2-0.9s0.6-0.3,0.9,0.2l0,0C18,11.1,18,11.1,17.5,11.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_7_00000026856178899725908950000012917867210346400690_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.5323,
    y1: 23.7062,
    x2: 20.0894,
    y2: 23.7062,
    gradientTransform: "matrix(1 0 0 -1 0 33.31)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    style: {
      fill: "url(#Path_7_00000026856178899725908950000012917867210346400690_)"
    },
    d: "M19.9,9.3 c0.3,0.5,0.3,0.5-0.2,0.9c-0.6,0.3-0.6,0.3-0.9-0.2c-0.4-0.7-0.4-0.7,0.2-1C19.5,8.7,19.5,8.7,19.9,9.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_8_00000018212520120774933320000007905283686437145248_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.7351,
    y1: 25.06,
    x2: 22.2967,
    y2: 25.06,
    gradientTransform: "matrix(1 0 0 -1 0 33.31)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    style: {
      fill: "url(#Path_8_00000018212520120774933320000007905283686437145248_)"
    },
    d: "M21.2,7.7 c0.5-0.3,0.5-0.3,0.9,0.2s0.3,0.6-0.2,0.9c-0.6,0.3-0.6,0.3-0.9-0.2C20.6,8,20.6,8,21.2,7.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_9_00000006673548128757122710000015872510934080804029_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.9563,
    y1: 26.464,
    x2: 24.5153,
    y2: 26.464,
    gradientTransform: "matrix(1 0 0 -1 0 33.31)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    style: {
      fill: "url(#Path_9_00000006673548128757122710000015872510934080804029_)"
    },
    d: "M24.3,6.6 c0.3,0.5,0.3,0.5-0.2,0.8c-0.6,0.3-0.6,0.3-0.9-0.2s-0.3-0.5,0.2-0.9S24,6.1,24.3,6.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_10_00000181808213830134637070000002560825508663723176_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.1579,
    y1: 27.697,
    x2: 26.7145,
    y2: 27.697,
    gradientTransform: "matrix(1 0 0 -1 0 33.31)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    style: {
      fill: "url(#Path_10_00000181808213830134637070000002560825508663723176_)"
    },
    d: "M26.5,5.3 c0.3,0.5,0.3,0.5-0.2,0.9c-0.6,0.3-0.6,0.3-0.9-0.2c-0.3-0.6-0.3-0.6,0.2-0.9C26.2,4.7,26.2,4.7,26.5,5.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightIcon);
export default __webpack_public_path__ + "static/media/flightIcon.c85be61b98d9327953166653375551f3.svg";
export { ForwardRef as ReactComponent };